<template>
  <div class="field-group-form grey lighten-5 mb-6">
    <div v-if="groupLabel">
      <v-divider class="white"></v-divider>
      <h6
        class="
          mt-1
          d-inline-block
          grey--text
          text--darken-3 text-body-2
          font-weight-bold
          px-2
        "
      >
        {{ groupLabel }}
      </h6>
      <v-divider v-if="groupLabel" class="orange lighten-3 mb-5 mx-2" />
    </div>
    <div class="pa-0 px-2 mt-2">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groupLabel: {
      type: String,
    },
  },
};
</script>

<style scoped></style>
